const initStrateArchiveBlog = () => {
    document.querySelectorAll('.js-archive-blog').forEach($el => {
        new StrateArchiveBlog($el);
    });
};

/**
 * @param {HTMLElement}                  $el                    Conteneur
 * @param {HTMLFormElement}              $categoriesSelectsForm Formulaire de sélection des catégorie
 * @param {NodeList.<HTMLSelectElement>} $categoriesSelects     Inputs de selection des catégories
 * @param {HTMLFormElement}              $searchForm            Formulaire de recherche
 * @param {HTMLElement}                  $ajaxContent           Element contenant les posts
 */
class StrateArchiveBlog {
    constructor($el) {
        this.$el = $el;
        this.$categoriesSelectsForm = this.$el.querySelector('.js-categories-select-form');
        if (this.$categoriesSelectsForm) {
            this.$categoriesSelects = this.$categoriesSelectsForm.querySelectorAll('.js-categories-select');
        }
        this.$searchForm = this.$el.querySelector('.js-search-form');
        this.$ajaxContent = this.$el.querySelector('#ajax_result');

        if (this.$categoriesSelects) {
            if (this.$categoriesSelects.length > 0) {
                this.bindCategoriesSelectsEvents();
            }
        }

        if (this.$searchForm) {
            this.bindSearchFormEvents();
        }

        this.bindPaginationEvents();
    }

    /**
     * Remplace le contenu de #ajax_result
     * quand l'utilisateur choisi une categorie
     */
    bindCategoriesSelectsEvents() {
        this.$categoriesSelectsForm.addEventListener('submit', evt => {
            evt.preventDefault();
        });

        this.$categoriesSelects.forEach($categoriesSelect => {
            $categoriesSelect.addEventListener('change', evt => {
                let queryString = this.getQueryStringOfForm(this.$categoriesSelectsForm);

                if (this.$searchForm) {
                    queryString = queryString.concat(this.getQueryStringOfForm(this.$searchForm));
                }

                queryString = queryString.join('&');
                const url = (this.$searchForm ? this.$searchForm.getAttribute('action') : this.$categoriesSelectsForm.getAttribute('action')) + (queryString.length > 0 ? '?' + queryString : '');
                this.replaceContent(url);
            });
        });
    }

    /**
     * 
     * Remplace le contenu de #ajax_result
     * quand l'utilisateur fait une recherche
     * 
     * @return {void}
     */
    bindSearchFormEvents() {
        this.$searchForm.addEventListener('submit', evt => {
            evt.preventDefault();

            let queryString = this.getQueryStringOfForm(this.$searchForm);
            
            if (this.$categoriesSelectsForm) {
                queryString = queryString.concat(this.getQueryStringOfForm(this.$categoriesSelectsForm));
            }

            queryString = queryString.join('&');
            const url = this.$searchForm.getAttribute('action') + (queryString.length > 0 ? '?' + queryString : '');
            this.replaceContent(url);
        });
    }

    /**
     * Remplace le contenu de #ajax_result
     * quand l'utilisateur clic sur un lien de pagination
     * 
     * @return {void}
     */
    bindPaginationEvents() {
        this.$el.addEventListener('click', evt => {
            if (evt.target.closest('.js-pagination .page-numbers:not(.current)')) {
                evt.preventDefault();

                this.replaceContent(evt.target.href);
            }
        });
    }

    /**
     * Retourne un tableau contenant "clé=valeur"
     * d'un formulaire
     * 
     * @param {HTMLElement} $form 
     * 
     * @return {Array}
     */
    getQueryStringOfForm($form) {
        const data = new FormData($form);
        const queryString = [];

        data.forEach((value, key) => {
            if (value) {
                queryString.push(`${key}=${value}`);
            }
        });

        return queryString;
    }

    /**
     * Remplace le contenu de #ajax_result
     * avec le contenu de la page accessible
     * via la variable url
     * 
     * @param {string} url 
     * 
     * @return {void}
     */
    replaceContent(url) {
        this.startLoading();
        let that = this;

        fetch(url).then(function (response) {
            return response.text();
        }).then(function (html) {

            // Convertit la string HTML objet document
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            
            // Remplacement du contenu
            that.$ajaxContent.innerHTML = doc.querySelector('#ajax_result').innerHTML;
            window.history.pushState({}, '', new URL(url.toString())); // Remplacement de l'url dans l'historique
            
            if (window.lazyLoadOptions) {
                new window.LazyLoad(window.lazyLoadOptions);
            }

            that.stopLoading();

        }).catch(function (err) {
            // Charge la page avec l'url renseigné s'il y a une erreur ajax
            window.location.href = url;
        });
    }

    /**
     * Start the loading
     * 
     * @return {void}
     */
    startLoading() {
        this.$el.classList.add('loading');
        location.hash = `#${this.$el.id}`;// Scroll top
    }

    /**
     * Stop the loading
     * 
     * @return {void}
     */
    stopLoading() {
        this.$el.classList.remove('loading');
    }
}

export default initStrateArchiveBlog;
